import React, { useState, useContext } from "react";
import { useToast } from "../context/ToastContext";
import { useNavigate } from "react-router-dom";
import { login } from "../services/authService";
import { fetchCapabilities, buildSubject } from "../services/capabilitiesService";
import { extractErrorMessage } from "../utils/errorUtils";
import { AuthContext } from "../context/AuthContext";
import { FaLock, FaArrowRight, FaUserShield, FaInfoCircle, FaEye, FaEyeSlash } from "react-icons/fa";
import { isAdminUser } from "../utils/roleUtils";
import "./Login.css";

function Login() {
  const [pin, setPin] = useState("");
  const [showPin, setShowPin] = useState(false);
  const [loading, setLoading] = useState(false);
  const { addToast } = useToast();
  const { setUser, setUiConfig } = useContext(AuthContext);
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await login(pin);
      const capabilities = await fetchCapabilities();
      const subject = buildSubject(capabilities);
      setUser(subject);
      setUiConfig(capabilities.uiConfig || null);
      navigate(isAdminUser(subject) ? "/admin" : "/employee");
    } catch (err) {
      console.error(err);
      const errorMessage = await extractErrorMessage(err, "Invalid PIN");
      addToast(errorMessage, "error");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-page">
      <div className="login-shell">
        <aside className="login-brand">
          <div className="login-brand-content">
            <div className="logo-icon">
              <FaUserShield />
            </div>
            <h2 className="login-title">The Heel Portal</h2>
          </div>
          <div className="login-footer">
            <p>© 2026 The Heel. Secure Employee Access.</p>
          </div>
        </aside>

        <div className="login-card">
          <div className="login-header">
            <p className="login-subtitle">Enter your secure PIN to access the workspace</p>
          </div>

          <form onSubmit={handleSubmit} className="login-form">
            <div className="input-group">
              <FaLock className="input-icon" />
              <input
                type={showPin ? "text" : "password"}
                maxLength={6}
                value={pin}
                onChange={(e) => setPin(e.target.value)}
                placeholder="6-Digit PIN"
                className="login-input"
                required
              />
              <button
                type="button"
                className="password-toggle-btn"
                onClick={() => setShowPin(!showPin)}
                tabIndex="-1"
              >
                {showPin ? <FaEyeSlash /> : <FaEye />}
              </button>
              <div className="info-icon-wrapper" title="Use your Homebase 6-digit login PIN">
                <FaInfoCircle />
              </div>
            </div>

            <button type="submit" disabled={loading} className="login-btn">
              {loading ? (
                <span className="loading-spinner"></span>
              ) : (
                <>
                  Access Portal <FaArrowRight className="btn-icon" />
                </>
              )}
            </button>

          </form>
        </div>
      </div>
    </div>
  );
}

export default Login;
